import React from 'react'
import ReservationBuilderActions from './actions/ReservationBuilderActions'
export default class ReservationBuilderCustomerInformation extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.renderFieldErrors = this.renderFieldErrors.bind(this);
    this.renderFieldClasses = this.renderFieldClasses.bind(this);
    this.autocomplete = null;
  };

  // *** Life Cycle Methods***/

  componentDidMount() {
    var self = this;

    //***  Google Places Autocomplete ***/

    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address'] })
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)

    //***  Select2 ***/
    if (`#customer-select`) {
      $(`#customer-select`).select2({
        ajax: {
          url: '/admin/customers_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: true,
        escapeMarkup: function (markup) { 
          return markup; 
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (customer) {
          if (customer.loading) {
            return customer.text;
          }

          return self.processCustomerName(customer);
        },
        templateSelection: function (customer) {
          if (customer && customer.id != null && customer.id != '' && (self.props.reservation.customer ? customer.id != self.props.reservation.customer.id : true))  {
            ReservationBuilderActions.setCustomer({
              id: customer.id,
              answers: customer.answers,
              salutation: customer.salutation,
              first_name: customer.first_name,
              middle_name: customer.middle_name,
              last_name: customer.last_name,
              email: customer.email,
              phone_number: customer.phone_number,
              formatted_phone: customer.formatted_phone,
              address_1: customer.address_1,
              address_2: customer.address_2,
              city: customer.city,
              state: customer.state,
              postal_code: customer.postal_code,
              country: customer.country,
            });
            ReservationBuilderActions.setEmojiState(customer.emoji_answers)
            ReservationBuilderActions.setRatingState(customer.rating_answers)
          } 
          return self.processCustomerName(customer);
        }
      }).on('select2:unselect', function () {
        ReservationBuilderActions.setCustomer({});
      });
    }
  }

  // *** Render methods ***// 

  render() { 
    if (!this.props.reservation.customer) {
      var customer = {
        id: '',
        salutation: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        phone_number: '',
        formatted_phone: '',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
      }
    } else {
      var customer = this.props.reservation.customer;

    }
    
    return (
      <fieldset>
        <div className="customer-information">
           
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{I18n.t('existing_customer')}</h3>
          </div>
          <div className="panel-body container">
            <div className="row">
              <div className="col-md-12 customer-select-wrapper">
                  <select className="form-control" ref="customer" id="customer-select">
                  {customer ? <option value={customer.id}>{this.processCustomerName(customer)}</option> : null}
                  </select>
              </div>
            </div>       
          </div>       
        </div>       

        <div className="panel panel-default">
          <div className="panel-heading"><h3 className="panel-title">{customer && customer.id ? I18n.t('edit_existing_customer') : I18n.t('create_new_customer')}</h3></div>
            <div className="panel-body container">
              <div className="row">
                <div className="col-md-12 customer-form-wrapper">
            
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>{I18n.t('salutation')}</label>
                        <input type="text" name="salutation" className="form-control" value={customer.salutation || ''} onChange={this.onChange} />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('first_name') + '*'}</label>
                        <input type="text" name="first_name" className={this.renderFieldClasses('first_name')} value={customer.first_name || ''} onChange={this.onChange} />
                        {this.renderFieldErrors('first_name')}
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('middle_name')}</label>
                        <input type="text" name="middle_name" className="form-control" value={customer.middle_name || ''} onChange={this.onChange} />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>{I18n.t('last_name') + '*'}</label>
                        <input type="text" name="last_name" className={this.renderFieldClasses('last_name')} value={customer.last_name || ''} onChange={this.onChange} />
                        {this.renderFieldErrors('last_name')}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('email_address') + '*'}</label>
                        <input type="text" name="email" className={this.renderFieldClasses('email')}  value={customer.email || ''} onChange={this.onChange} />
                        {this.renderFieldErrors('email')}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('mobile_number') + '*'}</label>
                        <input type="text" name="formatted_phone" className={this.renderFieldClasses('phone_number')} value={customer.formatted_phone || ''} onChange={this.onChange} />
                        {this.renderFieldErrors('phone_number')}
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>{I18n.t('address1')}</label>
                        <input type="text" id="autocomplete" name="address_1" className="form-control" value={customer.address_1 || ''} onChange={this.onChange} />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>{I18n.t('address2')}</label>
                        <input type="text" name="address_2" className="form-control" value={customer.address_2 || ''} onChange={this.onChange} />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('city')}</label>
                        <input type="text" name="city" className="form-control" value={customer.city || ''} onChange={this.onChange} />
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('state_province')}</label>
                        <input type="text" name="state" className="form-control" value={customer.state || ''} onChange={this.onChange} />
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('postal_code')}</label>
                        <input type="text" name="postal_code" className="form-control" value={customer.postal_code || ''} onChange={this.onChange} />
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>{I18n.t('country')}</label>
                        <input type="text" name="country" className="form-control" value={customer.country || ''} onChange={this.onChange} />
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    );
  };



   // ***Change Handlers***/

  onChange(event) {
    var customer = this.props.reservation.customer ? this.props.reservation.customer : {};
    customer[event.target.name] = event.target.value;
    this.forceUpdate();
    ReservationBuilderActions.setCustomer(customer);
  }

  handlePlaceSelect() {
    let addressObject = this.autocomplete.getPlace()
    let address = addressObject.address_components
    for(let i = 0, ilen = address.length; i < ilen; i++){
      for(let j = 0, jlen = address[i].types.length; j < jlen; j++){
        if(address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if(address[i].types[j] === "route") {
          var route = address[i].long_name
        } 
        if(address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if(address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if(address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if(address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }
    var customer = {
      ...this.props.reservation.customer,
      address_1: street_number ? `${street_number} ${route}` : route,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code
    }
    return ReservationBuilderActions.setCustomer(customer)
  }





  // *** Error Handling *** /

  renderFieldErrors(field) {
    if (this.props.errors) {
      var idx = 0
      var errors = this.props.errors.map( (error) => {
        
        if(error === "Phone Number is invalid " && field === 'phone_number') {
          idx = idx + 1 
          error = I18n.t("is_invalid") 
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Phone Number has already been taken " && field === 'phone_number') {
          idx = idx + 1
          error = I18n.t("has_already_been_taken")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Email is an invalid email address " && field === 'email') {
          idx = idx + 1 
          error = I18n.t("not_a_valid_email")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Email has already been taken " && field === 'email') {
          idx = idx + 1
          error = I18n.t("has_already_been_taken")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
  
  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if(this.props.errors){
      this.props.errors.forEach((error) => {
        if(error === "Phone Number is invalid " || error === "Phone Number has already been taken " && field === 'phone_number') {
          classname = classname + ' has-errors'
        } else if((error === "Email is an invalid email address " || error === "Email has already been taken ") && field === 'email') {  
        }
      })   
      return classname
    }
  }

  // *** Helper Methods *** //

  processCustomerName(customer) {
    if (customer.id && customer.first_name && customer.last_name) {
      var markup = customer.last_name + ', ' + customer.first_name + (customer.email ? ' (' + customer.email + ')' : '')
      if (customer.city && customer.state) {
        markup = markup + ' - ' + customer.city + ', ' + customer.state;
      }
      return markup;
    } else {
      return customer.text;
    }
  } 
};